import Header from "../Header";
import Game from "../Game";

function App() {
	return (
		<>
			<Header />

			<div className="game-wrapper">
				<Game />
			</div>
		</>
	);
}

export default App;
